import { ApolloError, ServerError } from '@apollo/client'

// Panel features that open the booking-details sections backed by admin-only BFF resolvers.
// Without them the BFF answers 403, so the section is not shown and its query is not sent.
export const BOOKING_HISTORY_FEATURE = 'booking.history.view'
export const COM_LOGS_FEATURE = 'com.logs.view'

export const canViewBookingHistory = (features: Set<string>): boolean =>
  features.has(BOOKING_HISTORY_FEATURE)

export const canViewComLogs = (features: Set<string>): boolean =>
  features.has(COM_LOGS_FEATURE)

// The BFF refuses a resolver the caller's role may not use with a plain HTTP 403 before
// GraphQL runs, so it reaches Apollo as a network error, not a GraphQL error.
export const isForbidden = (error: ApolloError): boolean =>
  (error.networkError as ServerError | null)?.statusCode === 403
